import { Component } from "@angular/core";
import {
  NavController,
  LoadingController,
  Platform,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import {
  StreamingMedia,
  StreamingVideoOptions
} from "@ionic-native/streaming-media";
import { HomeScreenService } from "../../services/HomeScreenService";

import { Helper } from "../../data/Helper";
import { HomeScreenGroupItem } from "../../data/HomeScreenGroupItem";
import { HomeScreenGroup } from "../../data/HomeScreenGroup";
import { Movie } from "../../data/Movie";
import { TvShow } from "../../data/TvShow";

import { ComingSoonService } from "../../services/ComingSoonService";
import { ComingSoon } from "../../data/ComingSoon";
import { Trailer } from "../../data/Trailer";
import { UserService } from "../../services/UserService";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  homeScreenGroups: HomeScreenGroup[] = [];
  private loaded = false;
  private comingSoonList: ComingSoon[] = [];
  private trailersList: Trailer[] = [];
  latestTrailer: any = {};

  constructor(
    private navCtrl: NavController,
    private streamingMedia: StreamingMedia,
    private loadingCtrl: LoadingController,
    private homeScreenService: HomeScreenService,
    private platform: Platform,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private userService: UserService,
    private comingSoonService: ComingSoonService,
    private alertController: AlertController
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad HomePage");

    this.getHomeScreenGroups();
    this.getTrailers();
  }

  getTrailers(): void {

    this.comingSoonService.getTrailers().then((result: any) => {
      this.trailersList = result.trailersList;
      console.log(this.trailersList);
      this.latestTrailer = this.trailersList[0];
      this.loaded = true;
    });
  }



  getHomeScreenGroups() {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Loading Home..."
    });

    //loading.present();

    this.homeScreenService.getHomeScreenGroups().then((result: any) => {
      this.homeScreenGroups = result.homeScreenGroups;

      console.log(this.homeScreenGroups);

      this.homeScreenGroups.forEach(homeScreenGroup => {
        // Get home screen movies first
        this.homeScreenService
          .getHomeScreenGroupMovies(homeScreenGroup)
          .then((result: any) => {
            result.homeScreenGroupMovies.forEach((movie: Movie) => {
              let movieGroupItem: any = {};

              movieGroupItem.itemId = movie.movieId;
              movieGroupItem.picture = movie.picture;
              movieGroupItem.videoUrl = movie.videoUrl;
              movieGroupItem.premiumStatus = movie.premiumStatus;
              movieGroupItem.isMovie = true;

              homeScreenGroup.groupItems.push(movieGroupItem);
            });

            // Then get home screen tv shows
            this.homeScreenService
              .getHomeScreenGroupTvShows(homeScreenGroup)
              .then((result: any) => {
                result.homeScreenGroupTvShows.forEach((tvShow: TvShow) => {
                  var movieGroupItem = new HomeScreenGroupItem();

                  movieGroupItem.itemId = tvShow.tvShowId;
                  movieGroupItem.picture = tvShow.picture;
                  movieGroupItem.isMovie = false;

                  homeScreenGroup.groupItems.push(movieGroupItem);
                });

                // Finally, shuffle them
                homeScreenGroup.groupItems = Helper.shuffle(
                  homeScreenGroup.groupItems
                );
              });
          });
      });

      //loading.dismiss();
    });
  }

  goToGroupItemDetails(groupItem) {
    if (groupItem.isMovie) {
      this.navCtrl.push("MovieDetailsPage", { movieId: groupItem.itemId, videoUrl: groupItem.videoUrl });
    } else {
      this.navCtrl.push("ShowDetailsPage", { tvShowId: groupItem.itemId, videoUrl: groupItem.videoUrl });
    }
  }

  navToPage(pageName) {
    this.navCtrl.push(pageName);
  }

  //Get trailer

  addTrailerToMyList(trailer) {
    let alert = this.alertCtrl.create({
      title: "Confirm",
      subTitle:
        `Add \`${trailer.name}\` to my list`,
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.getFavoutiteTrailers(trailer)
          }
        },
        {
          text: "Cancel",
          handler: () => {
           //
          }
        }
      ]
    });

    alert.present();
  }

  addTrailerReminder(trailer) {
    console.log(trailer)
    let alert = this.alertCtrl.create({
      title: "Confirm",
      subTitle:
        `Notify me when \`${trailer.name}\` is available to watch`,
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.checkIfInTrailerWaitingList(trailer);
          }
        },
        {
          text: "Cancel",
          handler: () => {
           //
          }
        }
      ]
    });

    alert.present();
  }

  checkIfInTrailerWaitingList(trailer) {
    let found = false;
    let uid = localStorage.getItem('loggedInUserUID')
    this.comingSoonService.trailerCheckIfWaiting(trailer.trailerId).then((res: any) => {
      let tokens = res.tokens;

      tokens.forEach(el => {
        if(el.userId == uid) {
          found = true;
        }
      });

      if(found) {
        this.sendNotification('Reminder already set!')
      } else {
        this.setTrailerReminder(trailer)
      }

      console.log(found);
    }).catch((err) => {
      console.error(err)
    });
  }

  setTrailerReminder(trailer) {
    let pushToken = localStorage.getItem('loggedInPushToken');
    console.log(trailer);
    let uid = localStorage.getItem('loggedInUserUID')
    this.comingSoonService.addToTrailerWaitingList(uid, trailer.trailerId, pushToken)
    .then((result: any) => {
      this.sendNotification(`You will be notified when ${trailer.name} is avalable to watch.`);
    }).catch((err) => {
      console.error(err);
    });
  }


  followTrailer(trailer) {
    //let pushToken = localStorage.getItem('loggedInPushToken');
    console.log(trailer);
    let uid = localStorage.getItem('loggedInUserUID')
    this.userService.addTrailerToMyList(uid, trailer)
    .then((result: any) => {
      this.sendNotification(`${trailer.name} added to your favorite list.`);
    }).catch((err) => {
      console.error(err);
    });
  }



  getFavoutiteTrailers(trailer) {

    let uid = localStorage.getItem('loggedInUserUID')
    let found: boolean = false;
    this.userService.getFavoriteTrailers(uid)
    .then((result: any) => {
      let trailers = result.trailers;

      trailers.forEach(el => {
        if(el.trailerId == trailer.trailerId) {
          found = true;
        }
      });

      console.log(found)

      if(found) {
        this.sendNotification(`\`${trailer.name}\` already added to your favourites list`)
      } else {
        this.followTrailer(trailer);
      }

      console.log(result.trailers);
    }).catch((err) => {
      console.error(err);
    });
  }

  sendNotification(message: string): void {
    let notification = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    notification.present();
  }

  playVideoTrailer(videoUrl) {
    if (!this.platform.is("cordova")) {
      let alert = this.alertController.create({
        title: "Run on device",
        subTitle: "This feature is only available on a device!",
        buttons: ["Dismiss"]
      });

      alert.present();
      return;
    }

    let options: StreamingVideoOptions = {
      successCallback: () => {
        console.log("Video played");
      },
      errorCallback: e => {
        console.log("Error streaming");
        console.log(JSON.stringify(e));
      },
      orientation: "landscape",
      shouldAutoClose: true,
      controls: true
    };
    //videoUrl = "https://firebasestorage.googleapis.com/v0/b/ionnetflix-72e25.appspot.com/o/Watch%20the%20Black%20Lightning%20Trailer.mp4?alt=media&token=3331cd39-f38b-4add-8d83-cec4c213b571"

    this.streamingMedia.playVideo(
      videoUrl,
      options
    );
  }

  openModal(video: any) {

    let modal = this.modalCtrl.create('ModalTrailerPage', {video: video});
    modal.present();
  }

  playVideoTrailerWeb(videoUrl) {


  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts